/**
 * Shape configuration based on the existing CSS custom properties
 */
export const shape = {
  borderRadius: 6, // Default border radius (--border-radius-md)
  borderRadiusSmall: 4, // Small border radius (--border-radius-sm)
  borderRadiusLarge: 8, // Large border radius (--border-radius-lg)
  borderRadiusExtraLarge: 12, // Extra large border radius (--border-radius-xl)
  borderRadiusRound: 9999, // Round border radius (--border-radius-full)
};